import * as React from "react";
import Styles from "./TeamRoster.module.scss";
import * as Team from "src/state/modules/team";
import { Text } from "src/components/atoms/Text/Text";
import { OldRow } from "src/components/atoms/OldGrid/OldRow";
import { ListRow, ListRowContainer } from "src/components/atoms/ListRow";
import { AvatarTypeOptions, getInitials } from "src/components/atoms/Avatar/Avatar";
import { EmptySection } from "../EmptySection";
import { ROUTES } from "src/utils/constants/routes";
import { sortPlayers } from "src/utils/sort-functions";
import { generatePath } from "react-router-dom";
import _ from "lodash";
import { playerDisplayName } from "src/state/modules/team/utils";
import { ProfileLinks } from "src/components/atoms/ProfileLinks/ProfileLinks";
import { isRecruitingAgeGroup } from "src/utils/player-profile-links";
interface TeamRosterProps {
  team: Team.Team;
  players: Team.Player[];
}

export const TeamRoster = ({ team, players }: TeamRosterProps) => {
  return (
    <>
      <OldRow padded={false} className={Styles.rosterHeaderRow}>
        <Text size={"medium"} weight={"bold"}>
          <>Roster ({`${players.length}`})</>
        </Text>
      </OldRow>
      {_.isEmpty(players) ? (
        <EmptySection iconType={"roster"} message={"No players added"} />
      ) : (
        <PlayerList team={team} players={players} />
      )}
    </>
  );
};

const PlayerList = ({ team, players }: { team: Team.Team; players: Team.Player[] }) => {
  // PG/PBR recruiting profiles only exist for 14U+, so only surface the lookup links there.
  const showProfileLinks = isRecruitingAgeGroup(team.ageGroup);

  return (
    <ListRowContainer>
      {sortPlayers(players)
        .filter((player) => {
          return player?.status !== "removed";
        })
        .map((player) => {
          const url = generatePath(ROUTES.teams.playerProfile, {
            id: player.team_id,
            pid: player.id,
          });
          const searchName = `${player.first_name ?? ""} ${player.last_name ?? ""}`.trim();

          return (
            <ListRow
              href={url}
              key={player.id}
              mainContent={playerDisplayName(player)}
              avatar={{ type: AvatarTypeOptions.Person }}
              intitials={getInitials({ firstName: player.first_name, lastName: player.last_name })}
              trailing={
                showProfileLinks && searchName ? (
                  <ProfileLinks variant="badge" name={searchName} state={team.state} />
                ) : undefined
              }
            />
          );
        })}
    </ListRowContainer>
  );
};
